import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';

const FAQ = () => {
  const [openItems, setOpenItems] = useState(new Set([0]));

  const faqItems = [
    {
      question: 'A consultoria é realmente gratuita?',
      answer: `Sim, nossa consultoria inicial é completamente gratuita e sem compromisso. Durante essa sessão, analisamos suas necessidades, apresentamos possibilidades e fornecemos orientações valiosas sobre seu projeto.\n\nSomente cobramos pelos serviços após a aprovação do orçamento e assinatura do contrato.`
    },
    {
      question: 'Quanto tempo leva para produzir um móvel personalizado?',
      answer: `O tempo de produção varia conforme a complexidade da peça:\n\n• Peças simples: 4-6 semanas\n• Móveis complexos: 8-10 semanas\n• Projetos completos: 10-16 semanas\n\nTodos os prazos são informados no orçamento e acompanhamos o progresso semanalmente.`
    },
    {
      question: 'Vocês atendem fora de São Paulo?',
      answer: `Sim! Atendemos em toda a Grande São Paulo para consultorias domiciliares. Para outras regiões, oferecemos:\n\n• Consultoria virtual detalhada\n• Envio de amostras de materiais\n• Coordenação remota do projeto\n• Entrega especializada em todo o Brasil`
    },
    {
      question: 'Qual é a faixa de preço dos móveis?',
      answer: `Nossos preços variam conforme materiais, acabamentos e complexidade:\n\n• Peças pequenas: R$ 2.000 - R$ 8.000\n• Móveis médios: R$ 8.000 - R$ 25.000\n• Peças grandes: R$ 25.000 - R$ 80.000\n• Projetos completos: A partir de R$ 50.000\n\nTodos os orçamentos são personalizados e detalhados.`
    },
    {
      question: 'Que tipo de garantia vocês oferecem?',
      answer: `Oferecemos garantia completa:\n\n• 5 anos para estrutura e junções\n• 2 anos para acabamentos e ferragens\n• 1 ano para componentes eletrônicos\n• Manutenção gratuita no primeiro ano\n• Suporte técnico vitalício`
    },
    {
      question: 'Posso acompanhar a produção do meu móvel?',
      answer: `Absolutamente! Mantemos você informado durante todo o processo:\n\n• Fotos semanais do progresso\n• Atualizações via WhatsApp\n• Visitas ao ateliê (agendadas)\n• Aprovação de etapas importantes\n• Cronograma detalhado atualizado`
    },
    {
      question: 'Vocês trabalham com que tipos de madeira?',
      answer: `Trabalhamos com madeiras nobres nacionais e importadas:\n\n• Nacionais: Jatobá, Ipê, Cumaru, Freijó\n• Importadas: Carvalho, Nogueira, Cerejeira\n• Sustentáveis: Eucalipto, Pinus tratado\n• Exóticas: Teca, Mogno (certificado)\n\nTodas com certificação de origem sustentável.`
    },
    {
      question: 'É possível fazer alterações durante a produção?',
      answer: `Sim, mas depende da etapa do projeto:\n\n• Antes do início: Alterações livres\n• Primeiras 2 semanas: Pequenos ajustes\n• Após 50% concluído: Apenas acabamentos\n• Etapa final: Somente detalhes menores\n\nSempre avaliamos a viabilidade e impacto no prazo.`
    }
  ];

  const toggleItem = (index) => {
    const newOpenItems = new Set(openItems);
    if (newOpenItems?.has(index)) {
      newOpenItems?.delete(index);
    } else {
      newOpenItems?.add(index);
    }
    setOpenItems(newOpenItems);
  };

  return (
    <section className="py-16 lg:py-24 bg-muted">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="font-playfair text-3xl lg:text-4xl font-bold text-primary mb-4">
            Perguntas Frequentes
          </h2>
          <p className="text-xl text-text-secondary">
            Esclarecemos as principais dúvidas sobre nossos serviços e processos
          </p>
        </div>

        <div className="space-y-4">
          {faqItems?.map((item, index) => (
            <div
              key={index}
              className="bg-card rounded-xl border border-border overflow-hidden shadow-sm hover:shadow-premium transition-all duration-300"
            >
              <button
                onClick={() => toggleItem(index)}
                className="w-full px-6 py-6 text-left flex items-center justify-between hover:bg-muted/50 transition-colors duration-200"
              >
                <h3 className="font-semibold text-primary text-lg pr-4">
                  {item?.question}
                </h3>
                <div className={`transform transition-transform duration-300 ${
                  openItems?.has(index) ? 'rotate-180' : ''
                }`}>
                  <Icon name="ChevronDown" size={20} color="var(--color-primary)" />
                </div>
              </button>
              
              <div className={`transition-all duration-300 ${
                openItems?.has(index) 
                  ? 'max-h-96 opacity-100' :'max-h-0 opacity-0 overflow-hidden'
              }`}>
                <div className="px-6 pb-6">
                  <div className="text-text-primary leading-relaxed whitespace-pre-line">
                    {item?.answer}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-12 text-center">
          <div className="bg-card rounded-xl p-8 border border-border">
            <Icon name="HelpCircle" size={32} color="var(--color-primary)" className="mx-auto mb-4" />
            <h3 className="font-playfair text-xl font-semibold text-primary mb-2">
              Não encontrou sua resposta?
            </h3>
            <p className="text-text-secondary mb-6">
              Nossa equipe está pronta para esclarecer qualquer dúvida específica sobre seu projeto
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <button className="bg-primary text-primary-foreground px-6 py-3 rounded-lg font-semibold hover:bg-primary/90 transition-colors duration-300 flex items-center justify-center space-x-2">
                <Icon name="MessageCircle" size={18} />
                <span>Perguntar no WhatsApp</span>
              </button>
              <button className="border border-primary text-primary px-6 py-3 rounded-lg font-semibold hover:bg-primary hover:text-primary-foreground transition-colors duration-300 flex items-center justify-center space-x-2">
                <Icon name="Mail" size={18} />
                <span>Enviar E-mail</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQ;